var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88472 1.94855H2.6478C2.46281 1.94855 2.29103 1.95515 2.13246 1.96176C0.566626 2.05426 0.150391 2.62906 0.150391 4.41294V4.79614C0.150391 5.15952 0.447701 5.45683 0.811081 5.45683H10.7214C11.0848 5.45683 11.3821 5.15952 11.3821 4.79614V4.41294C11.3821 2.44407 10.88 1.94855 8.88472 1.94855Z",
    fill: "#221C35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.811081 6.4469C0.447701 6.4469 0.150391 6.74421 0.150391 7.10759V9.0302C0.150391 10.9991 0.652516 11.4946 2.6478 11.4946H8.88472C10.847 11.4946 11.3623 11.0189 11.3821 9.13591V7.10759C11.3821 6.74421 11.0848 6.4469 10.7214 6.4469H0.811081ZM3.42742 9.88249H2.29764C2.02675 9.88249 1.80212 9.65786 1.80212 9.38697C1.80212 9.11609 2.02675 8.89146 2.29764 8.89146H3.43402C3.70491 8.89146 3.92954 9.11609 3.92954 9.38697C3.92954 9.65786 3.70491 9.88249 3.42742 9.88249ZM7.12068 9.88249H4.8479C4.57702 9.88249 4.35238 9.65786 4.35238 9.38697C4.35238 9.11609 4.57702 8.89146 4.8479 8.89146H7.12068C7.39156 8.89146 7.6162 9.11609 7.6162 9.38697C7.6162 9.65786 7.39817 9.88249 7.12068 9.88249Z",
    fill: "#221C35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3657 6.42855V2.9665C13.3657 0.89854 12.1831 0 10.3992 0H4.4992C3.99707 0 3.54781 0.0726759 3.15139 0.224635C2.84087 0.336952 2.56338 0.502125 2.33874 0.720153C2.21982 0.83247 2.31231 1.01746 2.48409 1.01746H9.66582C11.1524 1.01746 12.3548 2.21992 12.3548 3.70648V8.44366C12.3548 8.60883 12.5332 8.70132 12.6521 8.5824C13.108 8.1001 13.3657 7.39316 13.3657 6.42855Z",
    fill: "#221C35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCardIcon);
export default __webpack_public_path__ + "static/media/my_card_icon.f21ac2b606058b6720c33fd9ef5e0707.svg";
export { ForwardRef as ReactComponent };